<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Report List
    </hero-bar>
    <section class="section is-main-section has-listing-table">
      <div class="level no-margin">
        <div class="level-left bulk-actions">
          <div>
            <span class="navbar-item">
              <a @click.prevent="exportReportRun()" data-cy="pd-bulk-edit"
                >Export</a
              >
            </span>
          </div>
          <div class="level-left" v-if="isEditAllowed">
            <span class="navbar-item">
              <a @click.prevent="generateBulkReportRun()" data-cy="pd-bulk-edit"
                >Generate</a
              >
            </span>
          </div>
        </div>
        <div class="level-right">
          <div
            class="level-left current-report-default-view-with-icon"
            v-if="!isUserExternal && !isViewOnlyUser"
          >
            <span class="current-report-default-view-text">
              <b-field label="My Customers"></b-field>
            </span>
            <span class="additonal-info">
              <b-tooltip
                label="Shows data of customers where logged in user is added as CAM or Back-up CAM"
                type="is-primary is-light"
                position="is-left"
                multilined
                data-cy="rt-additonal-info"
              >
                <i class="mdi mdi-information" />
              </b-tooltip>
            </span>
          </div>
          <b-switch
            name="default_view"
            :checked="true"
            @input="showCamUserView"
            v-model="showCamUserDataReport"
            class="current-report-default-view-switch"
            data-cy="rt-switch-reports"
            v-if="!isUserExternal"
          />
          <b-dropdown position="is-bottom-left">
            <template #trigger>
              <a class="navbar-item navbar-mdi-tune-dropdown" slot="trigger">
                <button class="button" data-cy="column-config-button">
                  <span class="mdi mdi-table-cog mdi-24px mdi-dark"></span>
                </button>
              </a>
            </template>
            <form>
              <div class="filter-config-modal-body">
                <section class="filter-config-list">
                  <span>
                    <b-field
                      label="Column Configuration"
                      class="column_config"
                    ></b-field>
                  </span>
                  <div class="control">
                    <b-dropdown-item
                      aria-role="list"
                      :focusable="false"
                      custom
                      paddingless
                    >
                      <b-checkbox
                        @input="toggleAllColumns()"
                        v-model="selectAll"
                        @click.stop
                      >
                        <strong>Select All</strong>
                      </b-checkbox>
                    </b-dropdown-item>
                  </div>
                  <div
                    v-for="(column, index) in columnOptions"
                    :key="index"
                    class="control"
                  >
                    <div v-if="column.label != ''">
                      <b-dropdown-item
                        aria-role="list"
                        :focusable="false"
                        custom
                        paddingless
                      >
                        <b-checkbox
                          @input="saveFieldConfig()"
                          v-model="column.visible"
                          @click.stop
                        >
                          {{ column.label }}
                        </b-checkbox>
                      </b-dropdown-item>
                    </div>
                  </div>
                </section>
              </div>
            </form>
          </b-dropdown>
        </div>
      </div>
      <div class="enable-select-text">
        <circul8-table
          @clickcheck="checkCheckBox"
          @checkedAll="checkedAllData"
          :checkedRows="checkedRow"
          :records="data"
          :fields="computedColumns"
          :usePropRecords="true"
          :listingComponent="true"
          :isCheckable="true"
          :maxTextLength="'48'"
          :isLoading="isDataLoading"
          :showEditButton="false"
          :backendSortingEnabled="true"
          :routeNext="false"
          @downloadFile="downloadTemplateFile"
          @clickEdit="clickEditRule"
          @clickView="clickViewReportRun"
          @backendSort="sortData"
          @querySet="searchByFilter"
          :enableInfiniteScroll="true"
          @loadNextPage="pullNextPage"
          :hasNextData="nextData"
          :hasPreviousData="previousData"
          @loadPreviousPage="pullPreviousPage"
          :allCountries="countries"
          :allCustomers="mainCustomers"
          :allCAMs="userListCAM"
          :allRRs="userListRR"
          :showPlayButton="isEditAllowed"
          @playActionClicked="generateReportRun"
          :tableName="tblName"
          :saveDataFields="true"
          @customerSelectionChanged="updateParentCustomerOptions"
          :newTableHeight="'70vh'"
        />
      </div>
      <div class="records-displayed" v-if="totalRecords > 0">
        <!-- Display records count when we have records -->
        <span v-if="currentPage === 1">
          displaying 1 - {{ Math.min(data.length, 50, totalRecords) }} records
          out of {{ totalRecords }} records
        </span>
        <span v-else-if="currentPage === 2">
          displaying 1 -
          {{ Math.min(currentPage * 50, totalRecords) }}
          records out of {{ totalRecords }} records
        </span>
        <span v-else>
          displaying {{ (currentPage - 1) * 50 + 1 }} -
          {{ Math.min(currentPage * 50, totalRecords) }}
          records out of {{ totalRecords }} records
        </span>
      </div>
    </section>
    <b-notification :closable="false">
      <b-loading
        :is-full-page="true"
        v-model="isLoading"
        :can-cancel="false"
      ></b-loading>
    </b-notification>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import Circul8Table from "../../components/Circul8Table.vue";
import RulesManagerService from "../../services/RulesManagerService";
import ReportManagerService from "../../services/ReportManagerDataService";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import UserDataService from "../../services/UserDataService";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import { UserGroup } from "@/services/UserGroups";
import PageCache from "@/utils/PageCache";
export default {
  name: "ReportsList",
  mixins: [UserPermissionMixin, UtilityMixin, ScopeMixin],
  components: {
    HeroBar,
    TitleBar,
    Circul8Table
  },
  data() {
    return {
      selectAll: true,
      showCamUserDataReport: false,
      checkedData: [],
      checkedRow: [],
      map1: new Map(),
      isCheckedAll: false,
      checkedDataMap: new Map(),
      tblName: "ReportsList",
      isViewSyntexModalActive: false,
      isViewModalActive: false,
      isCopy: false,
      data: [],
      formData: {},
      isDataLoading: false,
      isModalActive: false,
      isCreateRulesModalActive: false,
      action: null,
      isAdd: false,
      editObject: this.getClearFormObject(),
      viewOnly: false,
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: false,
      nextData: false,
      previousData: false,
      mainCustomers: [],
      customerEntities: [],
      currentPage: 1,
      lastNavigationTime: 0,
      lastNavigationDirection: null,
      tree: {},
      customerMap: {},
      customerRRMap: {},
      userListCAM: [],
      userListRR: [],
      query: "",
      status: [],
      switchCustomerId: -1,
      columns: [
        {
          field: "r_id",
          label: "ID",
          searchable: true,
          visible: true,
          sticky: true,
          type: "input",
          filterKey: { r_id: "" }
        },
        {
          field: "customer_name",
          label: "Customer Name",
          searchable: true,
          type: "multiSelectFilter",
          visible: true,
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "additional_info",
          allStatusVals: this.mainCustomers,
          initStatusVals: [],
          multiSelectFilter: true,
          filterKey: { customer_name: [] },
          width: "200"
        },
        {
          field: "parent_customer_id",
          label: "Local Entity",
          searchable: true,
          width: "200",
          type: "multiSelectFilter",
          visible: true,
          allStatusVals: this.customerEntities,
          initStatusVals: [],
          multiSelectFilter: true,
          filterKey: { parent_customer_id: [] }
        },
        {
          field: "country_name",
          label: "Country",
          searchable: true,
          visible: true,
          searchKey: "country",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: this.countries,
          filterKey: { country_name: [] },
          width: "200"
        },
        {
          field: "stream_name",
          label: "Stream",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.stream,
          filterKey: { stream_name: [] }
        },
        {
          field: "scheme_name",
          label: "Scheme",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.containers,
          filterKey: { scheme_name: "" }
        },
        {
          field: "report_type",
          label: "Report Type",
          type: "input",
          searchable: true,
          visible: true,
          filterKey: { report_type: "" }
        },
        {
          field: "report_status",
          label: "Report Status",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          width: "200",
          initStatusVals: [],
          excludeForExternalUser: true,
          allStatusVals: [
            { name: "New" },
            { name: "Scheduled" },
            { name: "Calculation In Progress" },
            { name: "Calculated" },
            { name: "Failed" },
            { name: "Sent for CAM Approval" },
            { name: "Sent for Customer Approval" },
            { name: "Rejected by CAM" },
            { name: "Rejected by Customer" },
            { name: "Reopened" },
            { name: "Approved" }
          ],
          filterKey: {
            report_status: [],
            field_name: "name"
          }
        },
        {
          field: "report_status",
          label: "Report Status",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          width: "200",
          initStatusVals: [],
          hideForAdmin: true,
          allStatusVals: [
            { name: "Sent for Customer Approval" },
            { name: "Approved" },
            { name: "Rejected by Customer" }
          ],
          filterKey: {
            report_status: [],
            field_name: "name"
          }
        },
        {
          field: "reporting_tracker_status",
          label: "Reporting Tracker Status",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          width: "300",
          initStatusVals: [],
          allStatusVals: [
            { name: "New" },
            { name: "Raw data requested" },
            { name: "Raw data received" },
            { name: "In query/awaiting info" },
            { name: "Work in progress" },
            { name: "Awaiting approval" },
            { name: "Ready to submit" },
            { name: "Report not required" },
            { name: "Submitted" },
            { name: "Correction of data needed" },
            { name: "Submitted by customer" },
            { name: "No TD from customer" },
            { name: "Submitted Zero Submission" }
          ],
          filterKey: {
            reporting_tracker_status: [],
            field_name: "name"
          }
        },
        {
          field: "period",
          label: "Period",
          type: "input",
          searchable: true,
          visible: true,
          filterKey: { period: "" },
          width: "200"
        },
        {
          field: "planned_scheme_deadline",
          label: "Scheme Deadline",
          searchable: true,
          visible: true,
          type: "dateField",
          dateField: true,
          dateFilterKey: "planned_scheme_deadline_key",
          filterKey: { planned_scheme_deadline: [] },
          width: "300"
        },
        {
          field: "customer_account_manager",
          label: "Customer Account Manager",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.userListCAM,
          filterKey: { customer_account_manager: [] },
          width: "300"
        },
        {
          field: "reporting_responsible",
          label: "Reporting Responsible",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.userListRR,
          excludeForExternalUser: true,
          filterKey: { reporting_responsible: [] },
          width: "300"
        },
        {
          field: "failure_details",
          label: "Failure Details",
          type: "input",
          searchable: true,
          visible: true,
          excludeForExternalUser: true,
          filterKey: { failure_details: "" },
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "failure_details",
          width: "300"
        },
        {
          field: "generate_template",
          label: "Generated Template",
          searchable: true,
          visible: true,
          download: true,
          downloadIcon: "mdi mdi-download",
          initStatusVals: [],
          type: "input",
          filterKey: { generate_template: "" },
          width: "300"
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      customer: null,
      cacheKey: "reporting_list",
      RulesManagerService: new RulesManagerService(),
      ReportManagerService: new ReportManagerService(),
      userDataService: new UserDataService(),
      customerDataService: new CustomerProfileDataService()
    };
  },
  watch: {
    users(newValue) {
      this.assignUserDropdown(newValue);
    },
    customers(newValue) {
      this.fetchCustomersProfileData(newValue);
    },
    selectedCustomers: {
      handler(newSelectedCustomers) {
        if (this.parentCustomerIndex !== undefined) {
          this.updateParentCustomerOptions(newSelectedCustomers);
        }
      },
      deep: true
    }
  },
  mounted() {
    // Load saved column configuration
    const savedFieldConfig = localStorage.getItem(`report-list-field-config`);
    if (savedFieldConfig) {
      try {
        const fieldConfig = JSON.parse(savedFieldConfig);
        let allSelected = true;

        this.columns.forEach(column => {
          if (
            column.field !== "actions" &&
            fieldConfig[column.field] !== undefined
          ) {
            column.visible = fieldConfig[column.field];
            if (!column.visible) {
              allSelected = false;
            }
          }
        });

        // Update selectAll checkbox state based on whether all columns are visible
        this.selectAll = allSelected;
      } catch (e) {
        console.error("Error loading saved column configuration", e);
      }
    }

    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
      this.fetchCustomerProfileData(this.switchCustomerId, true);
    } else {
      this.fetchCustomerProfileData();
    }
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    this.fetchUserData();

    if (localStorage.getItem(this.tblName + "SaveDataFields")) {
      this.columns = JSON.parse(
        localStorage.getItem(this.tblName + "SaveDataFields")
      );
      // convert date string to object to auto populate in filter for date
      this.convertDateStringToObject();
    }
    if (localStorage.getItem(this.tblName + "Query")) {
      this.query = `${localStorage.getItem(this.tblName + "Query")}&`;
    }
    if (this.$route.query.r_id) {
      localStorage.removeItem(this.tableName + "SaveDataFields");
      localStorage.removeItem(this.tableName + "Query");
      this.query = "r_id=" + this.$route.query.r_id + "&";
      this.columns[0].filterKey = { r_id: this.$route.query.r_id };
      localStorage.setItem(this.tableName + "SaveDataFields", this.columns);
      localStorage.setItem(this.tableName + "Query", this.query);
    }
    if (this.switchCustomerId > 0) {
      this.query = this.query + "&switch_customer_id=" + this.switchCustomerId;
    }
    this.customerIndex = this.find_column_index("customer_name");
    this.parentCustomerIndex = this.find_column_index("parent_customer_id");

    // Only try to set up initial filtering if both indices are valid
    if (this.customerIndex !== -1 && this.parentCustomerIndex !== -1) {
      // Initial update of parent customer options
      if (
        this.columns[this.customerIndex]?.filterKey?.customer_name?.length > 0
      ) {
        this.updateParentCustomerOptions(
          this.columns[this.customerIndex].filterKey.customer_name
        );
      }
    }
    //this.fetchReportList(this.query);
    if (this.mappedCustomer && this.mappedCustomer.length > 0) {
      this.switchCustomerViewEnabled = true;
      this.getCustomerById();
    }
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal",
      "mappedCustomer"
    ]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Report Manager" },
        { url: "#", name: "Report List" }
      ];
    },
    isEditAllowed() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    },
    isViewOnlyUser() {
      return this.userGroups.includes(UserGroup.VIEW_ONLY_USER);
    },
    selectedCustomers() {
      // Only return if the indices are defined
      if (
        this.customerIndex !== undefined &&
        this.columns &&
        this.columns[this.customerIndex]
      ) {
        return this.columns[this.customerIndex].filterKey.customer_name;
      }
      return [];
    },
    computedColumns() {
      // Report tracker table columns differ for internal and external users
      const newColumns = [];
      if (this.isUserExternal || this.switchCustomerViewEnabled) {
        this.columns.forEach(col => {
          if (col.additionalInfo) {
            col.additionalInfo = false;
          }
          if (!col.excludeForExternalUser) {
            newColumns.push(col);
          }
        });
      } else {
        this.columns.forEach(col => {
          if (!col.hideForAdmin) {
            newColumns.push(col);
          }
        });
      }
      // Filter visible columns
      return newColumns.filter(column => column.visible !== false);
    },
    columnOptions() {
      // Column options for config dropdown - show all columns
      const newColumns = [];
      if (this.isUserExternal || this.switchCustomerViewEnabled) {
        this.columns.forEach(col => {
          if (col.additionalInfo) {
            col.additionalInfo = false;
          }
          if (!col.excludeForExternalUser) {
            newColumns.push(col);
          }
        });
      } else {
        this.columns.forEach(col => {
          if (!col.hideForAdmin) {
            newColumns.push(col);
          }
        });
      }
      return newColumns;
    }
  },
  methods: {
    // In ReportsList.vue
    updateParentCustomerOptions(selectedCustomers) {
      // Safety check: ensure customerEntities is initialized
      if (!this.customerEntities || this.customerEntities.length === 0) {
        return;
      }

      // Find the parent customer column index
      const parentCustomerIndex = this.find_column_index("parent_customer_id");
      // Get the IDs of selected customers
      const selectedCustomerIds = selectedCustomers.map(c => c.id);
      // Filter customer entities to only show those who are children of selected customers
      const filteredEntities = this.customerEntities.filter(entity => {
        // Only include entities where the parent_customer matches one of our selected customers
        return selectedCustomerIds.includes(entity.parent_customer);
      });

      // Update the dropdown options
      this.columns[parentCustomerIndex].allStatusVals =
        filteredEntities.length > 0 ? filteredEntities : this.customerEntities;
    },
    showCamUserView(value) {
      this.data = [];
      this.map1 = new Map();
      this.checkedRows = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      // check includes and replace
      this.query = this.query
        .replace(/cam_user=[^&]*&?/g, "")
        .replace(/&$/, "");
      this.query = this.query + "&cam_user=" + this.showCamUserDataReport;

      if (this.query.includes("page=")) {
        // replace pagination page parameter from query string
        this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      }
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.PreviousPageCursor = null;
      this.displayedRecords = 0;
      this.currentPage = 1;
      this.nextData = false;
      this.fetchReportList(this.query);
      localStorage.setItem("showCamUserDataReport", value);
    },
    getCustomerById() {
      let customerId = null;
      if (this.switchCustomerId) {
        customerId = this.switchCustomerId;
      }
      if (this.mappedCustomer.length > 0) {
        customerId = this.mappedCustomer[0];
      }
      this.customerDataService.getCustomerById(customerId).subscribe(
        response => {
          this.isLoading = false;
          this.customer = response;
        },
        e => {
          console.log(e);
          this.isLoading = false;
        }
      );
    },
    checkCheckBox(d) {
      // select all should be false now
      const total_checked = this.checkedData.length;
      const indexes = [];
      //getting the index of the checked rows
      d.forEach(element => {
        const index = this.data.findIndex(object => {
          return element.id === object.id;
        });
        indexes.push(index);
      });
      // create 2 dictionary. one with indexes for showing current page selected another with checked row value
      this.map1.set(this.currentPage, indexes);

      if (d.length > 0) {
        this.checkedDataMap.set(this.currentPage, d);
      } else {
        !this.isCheckedAll && this.checkedDataMap.set(this.currentPage, d);
      }
      this.checkedRow = d;
      this.checkedData = [];
      // converting mapped data into array for bulk operations
      this.checkedDataMap.forEach(element => {
        this.checkedData.push(...element);
      });
      // if checked all is true and deselect any
      if (this.isCheckedAll && total_checked > this.checkedData.length) {
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      }
    },
    checkedAllData(value) {
      this.isCheckedAll = value;
      if (!this.isCheckedAll) {
        this.checkedRow = [];
        this.map1 = new Map();
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
      } else {
        this.checkedDataMap.set(this.currentPage, this.data);
      }
    },
    convertDateStringToObject() {
      const planned_scheme_deadline = this.find_column_index(
        "planned_scheme_deadline"
      );
      if (
        this.columns[planned_scheme_deadline].filterKey.planned_scheme_deadline
          .length
      ) {
        this.columns[
          planned_scheme_deadline
        ].filterKey.planned_scheme_deadline[0] = new Date(
          this.columns[
            planned_scheme_deadline
          ].filterKey.planned_scheme_deadline[0]
        );
        this.columns[
          planned_scheme_deadline
        ].filterKey.planned_scheme_deadline[1] = new Date(
          this.columns[
            planned_scheme_deadline
          ].filterKey.planned_scheme_deadline[1]
        );
      }
    },
    generateBulkReportRun() {
      const msg =
        `Are you sure you want to run selected ` +
        this.checkedData?.length +
        ` records?`;
      if (this.checkedData.length == 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please select at least one Record",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
      if (this.checkedData.length || this.isCheckedAll) {
        try {
          if (this.checkedData.length > 20) {
            throw "invalid";
          }
          this.$buefy.dialog.confirm({
            title: "Confirmation",
            confirmText: "Yes",
            message: msg,
            trapFocus: true,
            onConfirm: value => this.generateReportRun()
          });
        } catch (e) {
          if (e == "invalid") {
            this.$buefy.dialog.alert({
              title: "",
              message: "Can not run more than 20 records"
            });

            this.isCheckedAll = false;
            this.checkedDataMap = new Map();
            this.checkedData = [];
            this.checkedRow = [];
            this.map1 = new Map();
          }
        }
      }
    },
    exportReportRun() {
      let msg = ``;
      if (this.isCheckedAll) {
        msg = `Are you sure you want to export all records?`;
      } else {
        msg =
          `Are you sure you want to export selected ` +
          this.checkedData?.length +
          ` records?`;
      }

      if (this.isCheckedAll && this.totalRecords > this.exportLargeCount) {
        msg =
          `Are you sure you want to export more than ` +
          this.exportLargeCount +
          ` records? Exported file will be sent to your email address`;
      } else if (this.checkedData.length == 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please select at least one Record",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
      if (this.checkedData.length || this.isCheckedAll) {
        try {
          this.$buefy.dialog.confirm({
            title: "Confirmation",
            confirmText: "Yes",
            message: msg,
            trapFocus: true,
            onConfirm: value => this.exportReportRunService()
          });
        } catch (e) {
          if (e == "invalid") {
            this.isCheckedAll = false;
            this.checkedDataMap = new Map();
            this.checkedData = [];
            this.checkedRow = [];
            this.map1 = new Map();
          }
        }
      }
    },
    generateReportRun(row) {
      this.isLoading = true;
      let query = "";
      let isBulkAction = false;
      this.isDataLoading = true;
      if (row) {
        query = "id=" + row.id + "&";
      } else {
        isBulkAction = true;
      }
      this.$buefy.toast.open({
        message: "Generating Report...",
        type: "is-success"
      });
      const checkedRecord = this.checkedData.map(records => records.id);
      const reportRunId = this.checkedData.map(
        records => records.report_run_id
      );
      this.ReportManagerService.generateReportRun(
        query,
        checkedRecord,
        reportRunId,
        isBulkAction
      ).subscribe(
        response => {
          if (response.success) {
            this.$buefy.dialog.alert({
              title: "Success",
              type: "is-success",
              canCancel: false,
              closeOnConfirm: true,
              message:
                "Report is generating. Please do not click the “Play” button again.."
            });
          } else {
            this.$buefy.dialog.alert({
              title: "Error",
              message: response.error,
              type: "is-danger"
            });
          }
          this.isCheckedAll = false;
          this.checkedDataMap = new Map();
          this.checkedData = [];
          this.checkedRow = [];
          this.map1 = new Map();
          setTimeout(() => {
            this.isLoading = false;
          }, 4000);
        },
        e => {
          this.handleApiError(e);
          this.isDataLoading = false;
        }
      );
      // Added loader
      setTimeout(() => {
        this.isDataLoading = false;
      }, 2000); // Adjust delay as necessary
    },
    exportReportRunService(row) {
      let isBulkAction = false;
      this.isDataLoading = true;
      if (row) {
        this.query = "id=" + row.id + "&";
      } else {
        isBulkAction = true;
      }
      if (this.switchCustomerId > 0) {
        this.query = this.query + "&customer_id=" + this.switchCustomerId + "&";
      } else if (this.customer) {
        this.query = this.query + "&customer_id=" + this.customer.id + "&";
      } else {
        this.query = this.query + "&customer_id=" + -1 + "&";
      }
      let checkedRecord = this.checkedData.map(records => records.id);
      let reportRunId = this.checkedData.map(records => records.report_run_id);
      if (this.isCheckedAll) {
        reportRunId = [];
        checkedRecord = [];
      }
      try {
        this.ReportManagerService.exportReportRun(
          this.query,
          checkedRecord,
          reportRunId,
          isBulkAction,
          this.isCheckedAll
        );
        this.isDataLoading = false;
        this.isDataLoading = false;
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    downloadTemplateFile(data) {
      try {
        this.ReportManagerService.downloadTemplateFile(
          data.report_run_id,
          data.generate_template
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    fetchCustomersProfileData(customers) {
      this.mainCustomers = customers.filter(e => e.parent_customer == null);

      this.customerEntities = customers.filter(e => e.parent_customer != null);
      const customerIndex = this.find_column_index("customer_name");
      this.columns[customerIndex].allStatusVals = this.mainCustomers;
      const parentCustomerIndex = this.find_column_index("parent_customer_id");
      this.columns[parentCustomerIndex].allStatusVals = this.customerEntities;

      this.customerMap = this.prepareMasterData(customers);
      this.customerRRMap = this.prepareCustomerRRData(customers);
      if (localStorage.getItem("showCamUserDataReport")) {
        this.showCamUserDataReport = localStorage.getItem(
          "showCamUserDataReport"
        );
        this.query =
          this.query + "&cam_user" + "=" + this.showCamUserDataReport + "&";
      }
      this.fetchReportList(this.query);
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    prepareCustomerRRData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["reporting_responsible"];
      }
      return resultDict;
    },
    assignUserDropdown(users) {
      this.userListRR = this.filterUsers(users, "Reporting Responsible");
      const rrIndex = this.find_column_index("reporting_responsible");
      if (rrIndex > -1) {
        this.columns[rrIndex].allStatusVals = this.userListRR;
      }

      this.userListCAM = this.filterUsers(users, "Customer Account Manager");
      const camIndex = this.find_column_index("customer_account_manager");
      this.columns[camIndex].allStatusVals = this.userListCAM;
      if (this.data && this.data.length > 0) {
        for (const report in this.data) {
          const reportData = this.data[report];
          reportData["customer_account_manager"] = this.userMap[
            reportData["customer_account_manager"]
          ];
          reportData["reporting_responsible"] = this.userMap[
            reportData["reporting_responsible"]
          ];
        }
      }
    },
    fetchPropertyData() {
      this.isDataLoading = true;
      this.RulesManagerService.getPropertyConfig().subscribe(response => {
        this.$store.state.properties = response;
      });
    },
    fetchOperatorData() {
      this.isDataLoading = true;
      this.RulesManagerService.getOperatorConfig().subscribe(response => {
        this.$store.state.operators = response;
      });
    },
    copyCreatedRule(ruleId) {
      this.isCreateRulesModalActive = true;
      this.isModalActive = false;
      this.getRuleById(ruleId);
      this.isCopy = true;
    },

    getRuleById(ruleId) {
      this.RulesManagerService.getRuleById(ruleId).subscribe(response => {
        this.formData = response;
        if (this.isCopy) {
          this.formData.name = this.formData.name + " - Copy";
        }
      });
    },
    cancelCreateRule() {
      this.isCreateRulesModalActive = false;
    },
    cancelViewRule() {
      this.isViewModalActive = false;
    },
    createRule(formData) {
      if (this.action == "Edit") {
        this.RulesManagerService.editRule(
          this.editObject.id,
          formData
        ).subscribe(() => {
          this.$buefy.toast.open({
            message: "Data is edited successfully!",
            type: "is-success"
          });
          this.isCreateRulesModalActive = false;
          this.fetchReportList(this.query);
        }, this.handleApiError);
      } else {
        this.RulesManagerService.createRule(formData).subscribe(() => {
          this.$buefy.toast.open({
            message: "Data is added successfully!",
            type: "is-success"
          });
          this.isCreateRulesModalActive = false;
          this.fetchReportList(this.query);
        }, this.handleApiError);
      }
    },

    getClearFormObject() {
      return {
        id: null,
        country: null,
        scheme: null,
        stream: null
      };
    },
    cancelViewSyntex() {
      this.isViewSyntexModalActive = false;
    },
    openViewSyntex() {
      this.isViewSyntexModalActive = true;
    },
    clickAddRule() {
      this.viewOnly = false;
      this.action = "Add";
      this.isAdd = true;
      this.editObject = this.getClearFormObject();
      this.isModalActive = true;
    },
    editFromView(editObject) {
      this.isViewModalActive = false;
      this.action = "Edit";
      this.isAdd = true;
      this.editObject = editObject;
      this.isCreateRulesModalActive = true;
    },
    clickEditRule(editObject) {
      this.isCopy = false;
      this.isViewModalActive = false;
      this.viewOnly = false;
      this.action = "Edit";
      this.isAdd = true;
      this.editObject = editObject;
      this.isCreateRulesModalActive = true;
      this.getRuleById(editObject.id);
    },
    clickViewReportRun(editObject) {
      const route = this.$router.resolve({
        path: `/reportManager/reportList/view/${editObject.report_run_id}`,
        params: { editObject: editObject }
      });
      window.open(route.href, "_blank");
    },
    viewReport(editObject) {
      this.editObject = editObject;
      this.isViewModalActive = true;
      this.editObject = editObject;
      this.getRuleById(editObject.id);
    },

    addRule() {
      this.isCreateRulesModalActive = true;
    },

    editCancel() {
      this.isModalActive = false;
    },
    getDocumentNameOrCount(documentObj) {
      let docName = "";
      if (documentObj != null) {
        if (documentObj.length > 1) {
          docName = "2 files are uploaded";
        } else {
          docName = documentObj[0][2];
        }
      }
      return docName;
    },
    prepareData(data) {
      // Calculate displayed records based on current page and data length
      const displayedRecords = Math.min(
        this.currentPage * 50,
        this.totalRecords
      );

      // Update pagination status based on displayed records
      this.previousData = this.currentPage > 1;

      // Make sure we retain previous data flag when we're not at page 1
      if (this.currentPage > 1 && this.PreviousPageCursor === null) {
        // If we're beyond page 1 but don't have a previous cursor, set one
        this.PreviousPageCursor = `api/reports/?page=${this.currentPage - 1}`;
      }

      // Always ensure we have consistent data size
      // Cache the data again to ensure consistency
      if (data.length > 0) {
        PageCache.storePage(this.cacheKey, this.currentPage, data);
      }

      // Update next data flag based only on record count
      const hasMoreRecords = displayedRecords < this.totalRecords;
      this.nextData = hasMoreRecords;

      // Always ensure we have a next cursor if there are more records
      if (hasMoreRecords && !this.nextPageCursor) {
        this.nextPageCursor = `api/reports/?page=${this.currentPage + 1}`;
      }

      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["country_id"] = reportData["country"];
        reportData["stream_id"] = reportData["stream"];
        reportData["scheme_id"] = reportData["scheme"];
        if (Array.isArray(reportData["generate_template"])) {
          reportData["generate_template_downloadable"] =
            reportData["generate_template"];
        }
        if (reportData["generate_template"] != null) {
          if (!Array.isArray(reportData["generate_template"])) {
            reportData["generate_template"] =
              reportData["generate_template_downloadable"];
          }
          if (
            Array.isArray(reportData["generate_template"]) &&
            reportData["generate_template"].length === 0
          ) {
            data[report]["generate_template"] = "";
          } else if (
            Array.isArray(reportData["generate_template"]) &&
            reportData["generate_template"].length === 1
          ) {
            const document = reportData["generate_template"][0];
            reportData["generate_template"] = document["template_name"];
            reportData["generate_template_file_count"] = 1;
          } else if (
            Array.isArray(reportData["generate_template"]) &&
            reportData["generate_template"].length > 1
          ) {
            reportData[
              "generate_template"
            ] = `${reportData["generate_template"].length} files are uploaded`;
          }
        } else {
          data[report]["generate_template"] = "";
        }
        reportData["country"] = this.countryMap[reportData["country"]];
        reportData["stream"] = this.containerMap[reportData["stream"]];
        reportData["scheme"] = this.schemeMap[reportData["scheme"]];
        //reportData["customer_name"] = this.customerMap[reportData["customer"]];
        if (this.userMap[reportData["customer_account_manager"]]) {
          reportData["customer_account_manager"] = this.userMap[
            reportData["customer_account_manager"]
          ];
        }
        if (this.userMap[reportData["reporting_responsible"]]) {
          reportData["reporting_responsible"] = this.userMap[
            reportData["reporting_responsible"]
          ];
        }
        reportData["reporting_responsible_id"] =
          reportData["reporting_responsible"];

        reportData["updated_at"] = this.dateToLocalDate(
          reportData["updated_at"]
        );
        reportData["parent_customer_id"] = reportData["local_entity_name"];
        //reportData["active"] = reportData["active"] ? "Active" : "Deactive";
        reportData["disabledView"] = data[report].report_run_id
          ? reportData["report_status"] == "Failed" ||
            reportData["report_status"] == "New" ||
            reportData["report_status"] == "Scheduled"
            ? true
            : false
          : true;
        reportData["actions"] = true;
        reportData["delete"] = true;
        dataList.push(reportData);
      }
      // Always set the data directly without conditional logic
      // This ensures consistent behavior regardless of pagination direction
      this.data = dataList;
      this.isDataLoading = false;
    },
    filterUsers(users, role) {
      const newUsers = [];
      for (const user of users) {
        const epradmin = user.groups.filter(e => e.name === role);
        if (epradmin.length > 0) {
          newUsers.push(user);
        }
      }
      return newUsers;
    },
    pullNextPage() {
      // Don't proceed if loading
      if (this.isDataLoading) {
        return;
      }

      // Set loading state
      this.isDataLoading = true;
      this.loadMoreClicked = true;

      // Calculate the next page number
      const nextPage = this.currentPage + 1;

      // Check if we've already loaded all records
      const totalPagesEstimate = Math.ceil(this.totalRecords / 50);
      if (nextPage > totalPagesEstimate) {
        this.nextData = false;
        this.isDataLoading = false;
        return;
      }

      // Prevent page bounce by ignoring quick back navigation requests
      const lastNavTime = this.lastNavigationTime || 0;
      const now = Date.now();
      this.lastNavigationTime = now;

      // Skip if navigation is too quick (prevents loops)
      if (now - lastNavTime < 300 && this.lastNavigationDirection === "prev") {
        this.isDataLoading = false;
        return;
      }
      this.lastNavigationDirection = "next";

      // Store the current page's data in cache if not already there
      // This ensures we can navigate backwards later
      if (
        !PageCache.getPage(this.cacheKey, this.currentPage) &&
        this.data.length > 0
      ) {
        PageCache.storePage(this.cacheKey, this.currentPage, [...this.data]);
      }

      // Always enable previous page scrolling when moving forward
      this.previousData = true;

      // Set explicit previous page cursor for reliable back navigation
      this.PreviousPageCursor = `api/reports/?page=${this.currentPage}`;

      // Check if we have cached data for this page
      const cachedData = PageCache.getPage(this.cacheKey, nextPage);
      if (cachedData && cachedData.length > 0) {
        // Use cached data if available
        this.currentPage = nextPage;
        this.data = [...cachedData];

        // Always set these flags when using cached data
        this.previousData = this.currentPage > 1;

        // If we're not at the end, make sure next is enabled
        if (this.currentPage * 50 < this.totalRecords) {
          this.nextData = true;
          this.nextPageCursor =
            this.nextPageCursor || `api/reports/?page=${this.currentPage + 1}`;
        }

        this.prepareData(cachedData);
        this.isDataLoading = false;
        return;
      }

      // Update current page for the API call
      this.currentPage = nextPage;

      // Extract query parameters from nextPageCursor URL
      const queryParams = new URLSearchParams(
        this.nextPageCursor.split("?")[1] || ""
      );
      queryParams.set("page", this.currentPage.toString());
      // Add switch_customer_id if it exists
      if (this.switchCustomerId > 0) {
        queryParams.set("switch_customer_id", this.switchCustomerId.toString());
      }

      const query = "&" + queryParams.toString();
      this.isDataLoading = true;
      this.fetchReportList(query, "next");
    },
    pullPreviousPage() {
      // Don't proceed if loading
      if (this.isDataLoading) {
        return;
      }

      // Don't proceed if we're already at the first page
      if (this.currentPage <= 1) {
        this.previousData = false;
        return;
      }

      // Set loading state
      this.isDataLoading = true;
      this.loadPreviousClicked = true;

      // Prevent page bounce by ignoring quick back navigation requests
      const lastNavTime = this.lastNavigationTime || 0;
      const now = Date.now();
      this.lastNavigationTime = now;

      // Skip if navigation is too quick (prevents loops)
      if (now - lastNavTime < 300 && this.lastNavigationDirection === "next") {
        this.isDataLoading = false;
        return;
      }
      this.lastNavigationDirection = "prev";

      // Calculate the previous page number
      const prevPage = this.currentPage - 1;

      // Special case for page 2 to page 1 navigation
      if (prevPage === 1) {
        // Store current page data in cache before moving to page 1
        if (this.data.length > 0) {
          PageCache.storePage(this.cacheKey, this.currentPage, [...this.data]);
        }

        // Reset to page 1
        this.currentPage = 1;
        this.previousData = false;

        // Specifically disable forward/backward navigation during transition
        // to prevent recursive loops
        this.isDataLoading = true;
        this.nextData = false;
        this.previousData = false;

        // Restore navigation state after a short delay
        setTimeout(() => {
          // Ensure next data is properly enabled after transition
          if (this.totalRecords > 50) {
            this.nextData = true;
            this.nextPageCursor = `api/reports/?page=2`;
          }
        }, 100);

        // If we have cached data for page 1, use it
        const page1Cache = PageCache.getPage(this.cacheKey, 1);
        if (page1Cache && page1Cache.length > 0) {
          this.data = [...page1Cache];
          this.prepareData(page1Cache);
          this.isDataLoading = false;
          return;
        } else {
          // Fetch page 1 if not cached
          const originalQuery = this.query.replace(/page=[0-9.]{1,2}&/g, "");
          this.fetchReportList(originalQuery);
          return;
        }
      }

      // For all other pages, store the current page's data in cache
      if (
        !PageCache.getPage(this.cacheKey, this.currentPage) &&
        this.data.length > 0
      ) {
        PageCache.storePage(this.cacheKey, this.currentPage, [...this.data]);
      }

      // Check if we have cached data for the previous page
      const cachedData = PageCache.getPage(this.cacheKey, prevPage);
      if (cachedData && cachedData.length > 0) {
        // Use cached data if available
        this.currentPage = prevPage;
        this.data = [...cachedData];

        // Set appropriate pagination flags
        this.previousData = prevPage > 1;
        this.nextData = true;

        // Make sure we have the next page cursor set
        this.nextPageCursor = `api/reports/?page=${prevPage + 1}`;

        this.prepareData(cachedData);
        this.isDataLoading = false;
        return;
      }

      // Only decrement after checking cache to maintain proper page tracking
      this.currentPage = prevPage;

      // Extract base query from the previous cursor if available
      if (!this.PreviousPageCursor) {
        this.previousData = false; // Disable previous scrolling if no cursor
        return;
      }

      // Extract and modify query parameters
      const queryParams = new URLSearchParams(
        this.PreviousPageCursor.split("?")[1] || ""
      );
      queryParams.set("page", this.currentPage.toString());
      // Add switch_customer_id if it exists
      if (this.switchCustomerId > 0) {
        queryParams.set("switch_customer_id", this.switchCustomerId.toString());
      }

      const query = "&" + queryParams.toString();
      this.isDataLoading = true;
      this.fetchReportList(query, "prev");
    },

    searchByFilter(filterQuery) {
      // Reset all pagination related states
      this.loadMoreClicked = false;
      this.loadPreviousClicked = false;
      this.nextPageCursor = null;
      this.PreviousPageCursor = null;
      this.currentPage = 1; // Start at page 1 instead of 0
      this.data = [];
      this.map1 = new Map();
      this.checkedRows = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();

      // Reset pagination flags when filtering
      this.previousData = false;
      this.nextData = false;
      this.enableLoadMore = false;
      this.totalRecords = 0;

      if (localStorage.getItem("currentReportDefaultView")) {
        this.currentReportDefaultView = localStorage.getItem(
          "currentReportDefaultView"
        );
      }

      filterQuery += "default_view" + "=" + this.currentReportDefaultView + "&";

      // Always preserve switch_customer_id if it exists
      if (this.switchCustomerId) {
        filterQuery += "switch_customer_id=" + this.switchCustomerId + "&";
      }

      this.query = filterQuery;

      // Clear the cache when filtering to ensure fresh data
      PageCache.clearCache(this.cacheKey);

      // Parse the query to get selected customers
      const customerNameFilter = this.extractCustomerFilterFromQuery(
        filterQuery
      );

      // Update parent customer options based on customer selection
      if (customerNameFilter) {
        this.updateParentCustomerOptions(
          this.columns[this.customerIndex].filterKey.customer_name
        );
      }

      let query = "";
      // Maintaining sort column & order in separate varaibles
      if (this.lastSortColumn) {
        query += "order_field" + "=" + this.lastSortColumn + "&";
        query += "order_by" + "=" + this.lastSortOrder + "&";
        query += this.query;
      } else {
        query = this.query;
      }

      this.fetchReportList(query, true);
    },

    // Helper method to extract customer filter from query string
    extractCustomerFilterFromQuery(filterQuery) {
      // Simple check if customer_name appears in the filter query
      return filterQuery.includes("customer_name");
    },

    // Modify getFilteredCustomerTags to also update parent customer options
    getFilteredCustomerTags(text) {
      const customerIndex = this.find_column_index("customer_name");

      this.columns[customerIndex].allStatusVals = this.allCustomers.filter(
        option => {
          return (
            option.name
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0
          );
        }
      );

      // Update parent customer options whenever customer filter changes
      this.updateParentCustomerOptions(
        this.columns[customerIndex].filterKey.customer_name
      );
    },
    sortData(field, order) {
      // Reset all pagination related flags when sorting
      this.loadMoreClicked = false;
      this.loadPreviousClicked = false;
      this.nextPageCursor = null;
      this.PreviousPageCursor = null;
      this.currentPage = 1; // Start at page 1
      this.data = [];
      this.nextData = false;
      this.previousData = false;
      this.totalRecords = 0;

      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");

      PageCache.clearCache(this.cacheKey);
      if (localStorage.getItem("showCamUserDataReport")) {
        this.showCamUserDataReport = localStorage.getItem(
          "showCamUserDataReport"
        );
      }
      this.query = this.query
        .replace(/cam_user=[^&]*&?/g, "")
        .replace(/&$/, "");
      this.query = this.query + "&cam_user=" + this.showCamUserDataReport;

      const oldOrderField = "&order_field" + "=" + this.lastSortColumn;
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder;
      const newOrderField = "&order_field" + "=" + field;
      const newOrderValue = "&order_by" + "=" + order;

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.query = this.query
        .replace(/switch_customer_id=[^&]*&?/g, "")
        .replace(/&$/, "");
      this.query = this.query + "&switch_customer_id=" + this.switchCustomerId;
      this.fetchReportList(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    fetchReportList(query = "", scrollDir) {
      this.isDataLoading = true;

      // Reset navigation lock state when loading new data
      // This prevents navigation loops from persisting
      this.lastNavigationTime = 0;
      this.lastNavigationDirection = null;

      // Always update previousData flag based on current page
      this.previousData = this.currentPage > 1;

      // If we're navigating and have cached data for this page, use it
      if (scrollDir && PageCache.getPage(this.cacheKey, this.currentPage)) {
        const cachedData = PageCache.getPage(this.cacheKey, this.currentPage);
        this.data = cachedData;
        this.prepareData(cachedData);

        // Even with cached data, ensure pagination flags are correctly set
        this.previousData = this.currentPage > 1;

        // Check if we've reached the end based on current page and total records
        const currentDisplayedRecords = Math.min(
          this.currentPage * 50,
          this.totalRecords
        );

        // Only enable next page if we have a cursor and more records
        const hasNextCursor = this.nextPageCursor !== null;
        const hasMoreRecords = currentDisplayedRecords < this.totalRecords;

        this.nextData = hasNextCursor && hasMoreRecords;
        this.enableLoadMore = this.nextData;

        this.isDataLoading = false;
        return;
      }

      this.ReportManagerService.getReportListData(query).subscribe(
        response => {
          // Store current cursor as previous before updating with new response data
          if (scrollDir === "next") {
            // When going forward, current cursor becomes previous
            this.PreviousPageCursor = this.nextPageCursor;
          } else if (scrollDir === "prev") {
            // When going backward, store response previous cursor
            if (this.currentPage > 1) {
              this.PreviousPageCursor = response["previous"] || null;
            } else {
              // If we're at page 1, there is no previous page
              this.PreviousPageCursor = null;
            }
          } else {
            // For initial load or search/sort, store the previous cursor from response
            this.PreviousPageCursor = response["previous"];
          }

          // Always update next cursor from the API response
          this.nextPageCursor = response["next"];

          // Store the total record count from the API response
          // Only update total count on initial load or when we get a reliable count
          if (!scrollDir || scrollDir !== "next" || this.totalRecords === 0) {
            this.totalRecords = response["count"];
          }

          // Update pagination flags
          // Only enable previous page scrolling if we're on page 2 or higher
          this.previousData = this.currentPage > 1;

          // For nextData flag - always check based on record count

          // Calculate if we've reached the end based on current page and total records
          const currentDisplayedRecords = Math.min(
            this.currentPage * 50,
            this.totalRecords
          );

          const hasMoreRecords = currentDisplayedRecords < this.totalRecords;

          // Always enable next page if there are more records
          this.nextData = hasMoreRecords;

          // Generate synthetic next cursor if needed
          if (hasMoreRecords && !this.nextPageCursor) {
            this.nextPageCursor = `api/reports/?page=${this.currentPage + 1}`;
          }

          this.enableLoadMore = this.nextData;

          // Cache the original API response for this page
          PageCache.storePage(
            this.cacheKey,
            this.currentPage,
            response["results"]
          );

          let tempData = [];

          // Define targetRecordCount - always try to maintain 100 records
          const targetRecordCount = 100;

          if (scrollDir === "next") {
            // Add new results to the end of the current data list
            tempData = [...this.data, ...response["results"]];

            // Store this batch in a variable to ensure consistent behavior
            const currentDataBatch = [...tempData];

            // If we have more than targetRecordCount records, keep only the most recent ones
            if (tempData.length > targetRecordCount) {
              tempData = tempData.slice(-targetRecordCount);
            }

            // Store the full data in cache for consistent pagination
            if (currentDataBatch.length > 0) {
              // Store the accumulated data for this page
              PageCache.storePage(this.cacheKey, this.currentPage, tempData);
            }

            this.prepareData(tempData);
          } else if (scrollDir === "prev") {
            // Add new results to the beginning of the current data list
            tempData = [...response["results"], ...this.data];

            // Store this batch in a variable to ensure consistent behavior
            const currentDataBatch = [...tempData];

            // Always keep exactly targetRecordCount records when going backward for consistency
            if (tempData.length > targetRecordCount) {
              tempData = tempData.slice(0, targetRecordCount);
            }

            // Store the full data in cache for consistent pagination
            if (currentDataBatch.length > 0) {
              // Store the accumulated data for this page
              PageCache.storePage(this.cacheKey, this.currentPage, tempData);
            }

            // Make sure we have the next page cursor set correctly
            if (
              !this.nextPageCursor &&
              this.currentPage < Math.ceil(this.totalRecords / 50)
            ) {
              this.nextData = true;
              // If we don't have a next cursor but we're not at the end, fetch the next page info
              this.nextPageCursor = `api/reports/?page=${this.currentPage + 1}`;
            }

            this.prepareData(tempData);
          } else {
            this.prepareData(response["results"]);
          }
          this.isDataLoading = false;
        },
        error => {
          this.handleApiError(error);
          this.isLoading = false;
          this.isDataLoading = false;
        }
      );
    },
    /**
     * Resets the component to the first page
     * This is useful when needing to refresh the list completely
     * or when navigating back to top after scrolling through records
     */
    resetToFirstPage() {
      // Store current page data before resetting
      if (
        this.currentPage > 1 &&
        this.data.length > 0 &&
        !PageCache.getPage(this.cacheKey, this.currentPage)
      ) {
        PageCache.storePage(this.cacheKey, this.currentPage, [...this.data]);
      }

      // Reset pagination and loading flags
      this.currentPage = 1;
      this.previousData = false;
      this.loadMoreClicked = false;
      this.loadPreviousClicked = false;
      this.isDataLoading = true;

      // Keep next page navigation available if we have more than 50 records
      if (this.totalRecords > 50) {
        this.nextData = true;
        this.nextPageCursor = `api/reports/?page=2`;
      } else {
        this.nextData = false;
        this.nextPageCursor = null;
      }

      this.PreviousPageCursor = null;

      // Refresh page 1 data
      PageCache.clearPage(this.cacheKey, 1);

      // Fetch fresh data for first page
      this.fetchReportList(this.query);
    },

    saveFieldConfig() {
      const fieldConfig = {};
      this.columns.forEach(column => {
        if (column.field !== "actions") {
          fieldConfig[column.field] = column.visible;
        }
      });

      localStorage.setItem(
        `report-list-field-config`,
        JSON.stringify(fieldConfig)
      );

      // Update selectAll based on whether all columns are visible
      const allSelected = this.columns
        .filter(column => column.field !== "actions")
        .every(column => column.visible);
      this.selectAll = allSelected;

      // Force a re-render
      this.$forceUpdate();
    },

    toggleAllColumns() {
      this.columns.forEach(column => {
        if (column.field !== "actions") {
          column.visible = this.selectAll;
        }
      });
      this.saveFieldConfig();
    },

    handleApiError(reason) {
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "Invalid input";
        }
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.isDataLoading = false;
      this.isLoading = false;
    },

    deleteModal(editObject) {
      this.$buefy.dialog.confirm({
        title: "Deleting Rule",
        message: "Are you sure you want to <b>delete</b> this rule?",
        confirmText: "Delete rule",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deleteRule(editObject)
      });
    }
  }
};
</script>

<style scoped>
.filter-config-modal-body {
  padding: 10px 20px 0 20px;
}

.column_config {
  padding-bottom: 10px;
}
</style>
